import type { Theme } from '@mui/material/styles'

interface CreateGroupDragImageParams {
  event: React.DragEvent
  groupCount: number
  totalCapacity: number
  theme: Theme
}

/**
 * Creates and sets a custom drag image showing the number of groups and total capacity being dragged.
 * The drag image is temporarily added to the DOM and removed after being set.
 *
 * @param params - Configuration for the drag image
 * @param params.event - The drag event to attach the image to
 * @param params.groupCount - Number of groups being dragged
 * @param params.totalCapacity - Total capacity of all groups being dragged (in MW)
 * @param params.theme - MUI theme for styling the drag image
 */
export function createGroupDragImage({ event, groupCount, totalCapacity, theme }: CreateGroupDragImageParams): void {
  const dragImage = document.createElement('div')
  dragImage.style.position = 'absolute'
  dragImage.style.top = '-1000px'
  dragImage.style.padding = `${theme.spacing(1)} ${theme.spacing(1.5)}`
  dragImage.style.backgroundColor = theme.palette.primary.main
  dragImage.style.color = theme.palette.common.white
  dragImage.style.borderRadius = theme.shape.borderRadius + 'px'
  dragImage.style.fontSize = theme.typography.body2.fontSize as string
  dragImage.style.fontWeight = theme.typography.fontWeightBold + ''
  dragImage.textContent = `${groupCount} groups | ${totalCapacity.toFixed(2)} MW`

  document.body.appendChild(dragImage)
  event.dataTransfer.setDragImage(dragImage, 0, 0)

  // Clean up the temporary element after the drag image is set
  setTimeout(() => dragImage.remove(), 0)
}
